export { Headline, type HeadlineProps } from "./Headline";
